import { useUser } from "@/composables/user/user";
import { Layout } from "@/router/types";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login/helpers";
import { useRoute } from "vue-router";

export function useAppLayout() {
  const layout = ref<Layout>();

  const route = useRoute();
  const { user } = useUser();

  const recomputeLayout = async () => {
    // Prevent flickering when user is not logged in yet
    await checkUserOnInitialPageLoad();

    // Initial page load
    if (route.name === undefined) {
      return undefined;
    }

    layout.value = route.meta.layout ?? Layout.Default;
  };

  // immediate: true ensures recomputeLayout runs on mount even when the route is
  // already resolved before App.vue mounts (e.g., Nuxt's router initialises routes
  // before the app component tree is created, so a plain watch would never fire).
  watch(route, recomputeLayout, { immediate: true });
  watch(user, recomputeLayout);

  return {
    layout,
  };
}
